import React, { useEffect, useState } from "react";
import {
	Autocomplete,
	AutocompleteRenderGroupParams,
	InputLabel,
	TextField,
} from "@mui/material";
import moment from "moment-timezone";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import { NeutralColor, PrimaryColor } from "node-library/dist/colors";
import { SimpleTooltip } from "./tooltip";

interface Props {
	id: string;
	options: any;
	groupBy?: (option: any) => string;
	value: any;
	setValue: (value: any) => void;
	getOptionLabel: (option: any) => any;
	label?: string;
	description?: string;
	clearOptionFunction?: () => void;
	multiple?: boolean;
	disabled?: boolean;
}

function CommonAutoCompleteDropdown(props: Props) {
	const label: React.ReactNode = (
		<div className="common-text-input-label">
			<InputLabel
				id={props.id + "-label"}
				sx={{
					color: "black", // Change the color
					fontFamily: "Lexend, Segoe UI, Roboto, sans-serif", // Change the font family
				}}
			>
				{props.label}
			</InputLabel>
			{props.description && (
				<SimpleTooltip
					id={props.id + "-tooltip"}
					description={props.description}
					arrow
					placement="top"
				></SimpleTooltip>
			)}
		</div>
	);
	return (
		<div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
			{label}
			<Autocomplete
				disablePortal
				id={props.id}
				multiple={props.multiple}
				disabled={Boolean(props.disabled)}
				options={props.options}
				groupBy={props.groupBy}
				value={props.value}
				popupIcon={<KeyboardArrowDownIcon />} // Toggle icon based on open state
				onChange={(event, newValue) => {
					if (newValue !== null) {
						props.setValue(newValue);
					} else {
						if (props.clearOptionFunction) {
							props.clearOptionFunction();
						}
					}
				}}
				renderInput={(params) => (
					<TextField
						{...params}
						label=""
						sx={{
							"& .MuiOutlinedInput-root": {
								padding: "4px 9px", // Custom padding for input field

								"&:hover": {
									borderColor: PrimaryColor.PRIMARY_LV5, // Change border color on hover
								},
								//   '&.Mui-focused': {
								//     borderColor: 'red', // Change border color when focused
								//   },
							},
							"& .MuiOutlinedInput-root fieldset": {
								borderColor: NeutralColor.NEUTRAL_GREY_950, // Change border color
							},
						}}
					/>
				)}
				renderGroup={(params: AutocompleteRenderGroupParams) => (
					<li key={params.key}>
						<div>
							<div
								className="typography-body-01 typography-bold"
								style={{
									padding: "8px 15px",
								}}
							>
								{params.group}
							</div>
							<ul style={{ marginTop: 0 }}>{params.children}</ul>
						</div>
					</li>
				)}
				getOptionLabel={props.getOptionLabel}
				isOptionEqualToValue={(option, value) => option === value} // Comparison for selected value
			/>
		</div>
	);
}

export default CommonAutoCompleteDropdown;
